<template>
  <div class="global-layout">
    <global-notice v-if="false"></global-notice>
    <global-header :sub-title="subTitle" :menu="menu"></global-header>
    <div class="global-body"
         id="global-body"
         :style="bodyStyle">
      <slot></slot>
    </div>
    <global-footer v-if="footer"></global-footer>
  </div>
</template>

<script>
  import GlobalNotice from '../global-notice/index.vue';
  import GlobalHeader from '../global-header/index.vue';
  import GlobalFooter from '../global-footer/index.vue';

  export default {
    name: 'global-layout',

    props: {
      subTitle: {
        type: String,
        default: '',
      },
      menu: {
        type: Boolean,
        default: true,
      },
      footer: {
        type: Boolean,
        default: true,
      },
    },

    data () {
      return {
        bodyNewHeight: 0,
      };
    },

    computed: {
      bodyStyle () {
        const style = {};

        if (this.bodyNewHeight !== 0) {
          style.minHeight = `${this.bodyNewHeight}px`;
        }

        return style;
      },
    },

    methods: {
      resetBodyHeight () {
        const bodyHeight = window.document.body.clientHeight;
        const windowHeight = window.document.documentElement.clientHeight;
        const header = window.document.getElementById('global-header');
        const footer = window.document.getElementById('global-footer');
        let bodyNewHeight = 0;
        if (windowHeight > bodyHeight) {
          bodyNewHeight = windowHeight - header.getBoundingClientRect().height;

          if (footer) {
            bodyNewHeight = bodyNewHeight - footer.getBoundingClientRect().height;
          }
          this.$emit('get-body-new-height', bodyNewHeight);
          this.$set(this, 'bodyNewHeight', bodyNewHeight);
        }
      },
    },

    mounted () {
      // this.resetBodyHeight();
    },

    components: {
      GlobalNotice,
      GlobalHeader,
      GlobalFooter,
    },
  };
</script>

<style lang="less" src="./index.less"></style>
<style lang="less" src="../../styles/fixed.less"></style>
